(function () {
    'use strict';

    angular
        .module('Lavpop-store.components')
        .controller('OrdersInternalController', OrdersInternalController);

    /** @ngInject */
    function OrdersInternalController($scope, $rootScope, $q, $state, $timeout, $stateParams, HelperService, OrderService, AuthenticationService, ProviderService, ShippingCompanyService, DATA_EVENTS) {
        const vm = this;

        var removeWatchUnits = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            $state.go('app.orders');
        })

        $scope.$on('$destroy', () => {
            removeWatchUnits();
        })

        init();

        function getOrder() {
            const orderId = $stateParams.orderId;

            if (!orderId) {
                vm.isLoading = false;
                return;
            }

            const userId = AuthenticationService.getUserId();
            const unitId = AuthenticationService.getSelectedUnit().Id;

            OrderService
                .get(orderId, userId, unitId)
                .then(success => {
                    const orderProductsList = angular.isArray(success.Order_Product) ? success.Order_Product : [];
                    const availableProviders = angular.isArray(vm.providers) ? vm.providers : [];


                    // Get all units from the order
                    const units = orderProductsList.reduce((acc, cur) => {
                        if (!cur || !cur.Unit || !cur.Unit.Id)
                            return acc;

                        if (!acc.find(unit => (unit.Id == cur.Unit.Id)))
                            acc.push(cur.Unit);

                        return acc;
                    }, []);

                    let unitOrders = [];

                    for (let index = 0; index < units.length; index++) {
                        const unit = units[index];
                        const unitAddressList = angular.isArray(unit.Unit_Address) ? unit.Unit_Address : [];

                        let unitOrder = {
                            Address: unitAddressList.length ? unitAddressList[0].Address : null,
                            Id: unit.Id,
                            FantasyName: unit.FantasyName
                        };

                        let orderProducts = orderProductsList.filter(orderProduct => (orderProduct.UnitId == unit.Id));
                        let providers = orderProducts.reduce((accProvider, curOrderProduct) => {
                            const providerId = curOrderProduct &&
                                curOrderProduct.ProductValue &&
                                curOrderProduct.ProductValue.Product &&
                                curOrderProduct.ProductValue.Product.ProviderId;
                            const providerData = curOrderProduct &&
                                curOrderProduct.ProductValue &&
                                curOrderProduct.ProductValue.Product &&
                                curOrderProduct.ProductValue.Product.Provider;

                            if (!providerId || !providerData)
                                return accProvider;

                            if (!accProvider.find(provider => (providerId == provider.Id))) {
                                let provider = providerData;

                                provider.Products = orderProducts.filter(orderProduct => (
                                    orderProduct &&
                                    orderProduct.ProductValue &&
                                    orderProduct.ProductValue.Product &&
                                    orderProduct.ProductValue.Product.ProviderId == provider.Id
                                ));
                                provider.SubTotal = provider.Products.reduce((acc, cur) => acc += cur.Value * cur.Quantity, 0);

                                const providerOrderProduct = provider.Products[0];
                                if (!providerOrderProduct)
                                    return accProvider;

                                provider.SelectedShippingCompany = providerOrderProduct.ShippingCompany;
                                provider.SelectedPaymentCondition = providerOrderProduct.PaymentCondition;
                                provider.SelectedStatus = providerOrderProduct.OrderStatus;
                                provider.Invoice = providerOrderProduct.Invoice;

                                accProvider.push(provider);
                            }

                            return accProvider;
                        }, []);

                       unitOrder.Providers = providers.filter(provider => (availableProviders.find(prov => prov.Id == provider.Id)));

                        const firstOrderProduct = orderProducts[0];
                        unitOrder.CollectSolicitationDate = firstOrderProduct ? firstOrderProduct.CollectSolicitationDate : null;
                        unitOrder.CollectFinishedDate = firstOrderProduct ? firstOrderProduct.CollectFinishedDate : null;
                        unitOrder.CollectNumber = firstOrderProduct ? firstOrderProduct.CollectNumber : null;
                        unitOrder.Observation = firstOrderProduct ? firstOrderProduct.Observation : null;

                        unitOrders.push(unitOrder);
                    }

                    vm.units = unitOrders;
                    vm.orderData = success;
                    vm.isLoading = false;
                }, error => {
                    HelperService.errorCallback(error)

                    $timeout(() => {
                        $state.go('app.orders');
                        vm.isLoading = false;
                    }, 250);
                })
        }

        function getProviders() {
            return ProviderService
                .getAll()
                .then(
                    success => vm.providers = success,
                    error => HelperService.errorCallback(error))
        }

        function getShippingCompanies() {
            return ShippingCompanyService
                .getAll()
                .then(
                    success => vm.companies = success,
                    error => HelperService.errorCallback(error))
        }

        function init() {
            $rootScope.addDivisor = true;
            vm.isLoading = true;

            $q.all([getProviders(), getShippingCompanies()])
                .then(() => {
                    getOrder();
                });
        }
    }
}());
